import type { SanityPromoTag } from '../@types';

export const PROMO_TAG_ALL_PROMOTIONS_ID = 'promo-tag-all-promotions';
export const PROMO_TAG_PRODUCT_AVAILABILITY = {
  BOTH: 'both',
  SPORTSBOOK: 'sportsbook',
  CASINO: 'casino',
} as const;

export const ALL_PROMOTIONS_TAG: SanityPromoTag = {
  _id: PROMO_TAG_ALL_PROMOTIONS_ID,
  label: 'All Promotions',
  filterValue: PROMO_TAG_ALL_PROMOTIONS_ID,
  isSystem: true,
  productAvailability: PROMO_TAG_PRODUCT_AVAILABILITY.BOTH,
};
